import {
  fetchV1Suppliers,
  createV1Supplier,
} from "@/services/v1/purchaseAPIService";

export default {
  state: {
    suppliers: [],
    supplierPageSize: 5,
    totalSupplierCount: 0,
  },
  getters: {
    suppliers: (state) => state.suppliers,
    currentSupplierPageSize: (state) => state.supplierPageSize,
    totalSupplierCount: (state) => state.totalSupplierCount,
  },
  mutations: {
    SET_SUPPLIERS(state, suppliers) {
      state.suppliers = suppliers;
    },
    SET_SUPPLIER_PAGE_SIZE(state, pageSize) {
      state.supplierPageSize = pageSize;
    },
    SET_TOTAL_SUPPLIER_COUNT(state, count) {
      state.totalSupplierCount = count;
    },
  },
  actions: {
    async fetchSuppliers({ commit }, { page = 1, pageSize = 5 } = {}) {
      //   commit("SET_LOADING", true);
      try {
        const response = await fetchV1Suppliers(page, pageSize);
        commit("SET_SUPPLIERS", response.results);
        commit("SET_SUPPLIER_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_SUPPLIER_COUNT", response.count);
      } catch (error) {
        console.error("Error fetching Suppliers:", error);
      } finally {
        // commit("SET_LOADING", false);
        console.log("finally...");
      }
    },
    async addSupplier({ commit }, supplier) {
      try {
        const response = await createV1Supplier(supplier);
        if (response.error) {
          const errorMessages = [];
          errorMessages.push(response.message);
          // commit("SET_ERROR", errorMessages);
          return { success: false, message: response.message };
        }
        return { success: true, data: response };
      } catch (error) {
        const errorMessages = [];
        for (const [key, value] of Object.entries(error.response.data)) {
          errorMessages.push(value[0]);
          console.log(`supplier create... ${key}: ${value}`);
        }
        commit("SET_ERROR", errorMessages);
        const message = error.response?.data?.message || "Failed to add Supplier.";
        return { success: false, message };
      }
    },
  },
};
